import LocalStorage from "./LocalStorage";

type claimStatus = boolean;

export const saveClaimsStatus = (value: boolean) =>
  LocalStorage.setJSONValue("showClaims", { value });

const getStoredClaimsStatus = (): claimStatus | undefined =>
  LocalStorage.getJSONValue("showClaims")?.value === true;

const getShowClaimsFromUrl = (): claimStatus | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("showClaims")?.toLowerCase() === "true";
};

export const getShowClaimStatus = (): claimStatus => {
  const showClaimStatus =
    [getShowClaimsFromUrl(), getStoredClaimsStatus()].find(
      (status) => status
    ) || false;
  saveClaimsStatus(showClaimStatus);
  return showClaimStatus;
};
